import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setBreadcrumbsList } from 'src/store/breadcrumbs';

import { FinanceMarket } from './financeMarket/FinanceMarket';
import { CareFuture } from '../home/careFuture/CareFuture';
import { FewSteps } from '../home/fewSteps/FewSteps';
import { MarketEconomy } from './marketEconomy/MarketEconomy';
import { MarketOverview } from './marketOverview/MarketOverview';
import { MarketTypes } from './marketTypes/MarketTypes';
import { MarketFaq } from './marketFaq/MarketFaq';

import { BREADCRUMBS_DATA } from 'src/constants';

import './markets.scss';

export const Markets = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbsList(BREADCRUMBS_DATA.MARKETS));
  }, [dispatch]);

  return (
    <div className="markets">
      <FinanceMarket />
      <MarketEconomy />
      <MarketOverview />
      <MarketTypes />
      <CareFuture />
      <FewSteps />
      <MarketFaq />
    </div>
  );
};
